function AddAuthorizationHeaderInterceptor(store) {
  return function AddAuthorizationHeader(request, next) {
    if (store.state.auth.token) {
      request.headers.set('Authorization', `Bearer ${store.state.auth.token}`);
    }
    next();
  };
}

export default AddAuthorizationHeaderInterceptor;
